import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';

export type Severities = 'success' | 'warn' | 'info' | 'error'

@Component({
  selector: 'app-spinner-loading-pdf',
  templateUrl: './spinner-loading-pdf.component.html',
  styleUrls: ['./spinner-loading-pdf.component.css'],
  providers: [MessageService]
})
export class SpinnerLoadingPdfComponent {

  @Input('loading') loading = false

progress = 0;
loadingText = 'Inicializando...';
  constructor(
    private messageService: MessageService
  ) {}

  /**
   * @description Show message
   * @param title Title of the message
   * @param message Body message of the message
   */
  showMessage(title: string, message: string, severities: Severities) {
    this.messageService.add({
      severity: severities,
      summary: title,
      detail: message
    })
  }

}
